import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg, formatDate, useApi } from "@/lib/api";

export default function EmulatorPanel({ h, reload, onChange }) {
  const api = useApi();
  const [busy, setBusy] = useState("");
  const tok = h.tokens.emulator;
  const run = async (key, fn, ok) => {
    setBusy(key);
    try { const { data } = await fn(); if (data.mode) onChange(data); else await reload(); toast.success(ok); } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="space-y-4" data-testid="hosting-emulator">
      <div className="flex flex-wrap items-center gap-3">
        <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ${h.emulator_running ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-800"}`} data-testid="hosting-emulator-status">
          <span className={`h-2 w-2 rounded-full ${h.emulator_running ? "bg-emerald-500 animate-pulse" : "bg-amber-500"}`} />{h.emulator_running ? "Emulatore in esecuzione" : "Emulatore fermo"}
        </span>
        {!h.emulator_running && <Button size="sm" variant="outline" disabled={!!busy} onClick={() => run("start", () => api.post("/hosting/emulator/start"), "Emulatore avviato")} data-testid="hosting-emulator-start">
          {busy === "start" ? <Loader2 size={13} className="mr-1 animate-spin" /> : <Play size={13} className="mr-1" />}Avvia emulatore</Button>}
      </div>
      <p className="text-xs leading-relaxed text-slate-500">È un processo separato dallo Studio: se lo Studio si ferma, i siti pubblicati sull'emulatore continuano a rispondere. Gli indirizzi <span className="font-mono">*.{h.domain}</span> sono raggiungibili solo da questo server: dallo Studio usa «Prova dal server».</p>
      <div className="flex flex-wrap items-center gap-3 text-xs text-slate-600" data-testid="hosting-emulator-token">
        <KeyRound size={13} className="text-slate-400" />
        {tok.configured ? <>Token di prova salvato cifrato <span className="font-mono">{tok.masked}</span>{tok.verified_at && ` · verificato ${formatDate(tok.verified_at, true)}`}</> : "Nessun token salvato"}
        <Button size="sm" variant="outline" disabled={!!busy || !h.emulator_running} onClick={() => run("token", () => api.post("/hosting/emulator/test-token"), "Token di prova verificato e salvato")} data-testid="hosting-emulator-token-btn">
          {busy === "token" && <Loader2 size={13} className="mr-1 animate-spin" />}{tok.configured ? "Verifica di nuovo" : "Usa il token di prova"}</Button>
      </div>
    </div>
  );
}
